<template>
  <AppButtonOk @click="onClickNext">
    シミュレーション一覧へ
  </AppButtonOk>
</template>

<script>
export default {
  name: 'SimulationFooterButtonBackList',
  props: {
    toUrl: {
      type: String,
      default: '',
    },
    isReadOnly: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    async onClickNext() {
      if (!this.isReadOnly) {
        const result = await this.$confirm(
          'これまで設定した内容がすべて破棄されますがよろしいですか？',
        )
        if (result) {
          await this.$router.push(this.toUrl)
        }
        return
      }
      // readOnlyのときは確認を挟まない
      await this.$router.push(this.toUrl)
    },
  },
}
</script>

<style scoped></style>
